import { mapGetters } from "vuex";

export const userComputed = {
    ...mapGetters("users", ["loggedIn", "getType", "getRole", "getUser", "getMatch"])
};

export const fixturesComputed = {
    ...mapGetters("fixtures", ["getCities", "getLevels", "getProfessions", "getAreas", "getSegments", "getGenders", "getWorkingMode", "getWorkingDay", "getBenefits", "getDegree"])
};
